module.exports = __webpack_public_path__ + "assets/img/course-act-bg2.6cb1dd04.png";